(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2746],{

/***/ 24736:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/surf-forecasts/[subregionSlug]/[subregionId]",
      function () {
        return __webpack_require__(44935);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 10053:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bx": function() { return /* reexport safe */ _CTAs__WEBPACK_IMPORTED_MODULE_0__.Bx; },
/* harmony export */   "MJ": function() { return /* reexport safe */ _CTAs__WEBPACK_IMPORTED_MODULE_0__.MJ; },
/* harmony export */   "Yr": function() { return /* reexport safe */ _CTAs__WEBPACK_IMPORTED_MODULE_0__.Yr; },
/* harmony export */   "bK": function() { return /* reexport safe */ _CTAs__WEBPACK_IMPORTED_MODULE_0__.bK; },
/* harmony export */   "eq": function() { return /* reexport safe */ _CTAs__WEBPACK_IMPORTED_MODULE_0__.eq; },
/* harmony export */   "hU": function() { return /* reexport safe */ _CTAs__WEBPACK_IMPORTED_MODULE_0__.hU; },
/* harmony export */   "w1": function() { return /* reexport safe */ _CTAs__WEBPACK_IMPORTED_MODULE_0__.w1; },
/* harmony export */   "w8": function() { return /* reexport safe */ _CTAs__WEBPACK_IMPORTED_MODULE_0__.w8; },
/* harmony export */   "zH": function() { return /* reexport safe */ _CTAs__WEBPACK_IMPORTED_MODULE_0__.zH; }
/* harmony export */ });
/* harmony import */ var _CTAs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91344);



/***/ }),

/***/ 52117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10253);
/* harmony import */ var _surfline_web_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80660);
/* harmony import */ var _surfline_web_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32257);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37667);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34513);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77823);




var useJWPlayer = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(function() {
        // If the player was already loaded in a previous mount, return true
        if (_surfline_web_common__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z) {
            var win = (0,_surfline_web_common__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
            return !!(win === null || win === void 0 ? void 0 : win.jwplayer);
        }
        return false;
    }), jwPlayerLoaded = ref[0], setJwPlayerLoaded = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""), jwPlayerError = ref1[0], setJwPlayerError = ref1[1];
    // eslint-disable-next-line @typescript-eslint/no-unused-vars,@typescript-eslint/naming-convention
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,react_use__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
        return setJwPlayerError("JWPlayer loading timed out");
    }, 10000), 2), _isReady = ref2[0], cancel = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (jwPlayerLoaded || jwPlayerError) {
            cancel();
        }
    }, [
        jwPlayerLoaded,
        jwPlayerError,
        cancel
    ]);
    // Cancel the timer when we unmount
    (0,react_use__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
        cancel();
    });
    return {
        jwPlayerLoaded: jwPlayerLoaded,
        jwPlayerError: jwPlayerError,
        setJwPlayerLoaded: setJwPlayerLoaded,
        setJwPlayerError: setJwPlayerError
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useJWPlayer);


/***/ }),

/***/ 44935:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _subregionId_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: external "React"
var external_React_ = __webpack_require__(37667);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__(2664);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
// EXTERNAL MODULE: ./node_modules/@surfline/web-common/esm/selectors/user.js
var user = __webpack_require__(61395);
// EXTERNAL MODULE: ./node_modules/@surfline/web-common/esm/getClientIp.js
var getClientIp = __webpack_require__(21080);
// EXTERNAL MODULE: ./src/actions/subregion.js + 1 modules
var actions_subregion = __webpack_require__(71551);
// EXTERNAL MODULE: ./src/actions/swellEvents.ts
var swellEvents = __webpack_require__(151);
// EXTERNAL MODULE: ./src/actions/user.ts
var actions_user = __webpack_require__(3001);
// EXTERNAL MODULE: ./src/common/constants.ts
var constants = __webpack_require__(50132);
// EXTERNAL MODULE: ./src/common/permissions.ts
var permissions = __webpack_require__(9326);
// EXTERNAL MODULE: ./src/components/CTAs/index.ts
var CTAs = __webpack_require__(10053);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@surfline/quiver-react/esm/Spinner/Spinner.js
var Spinner = __webpack_require__(40641);
// EXTERNAL MODULE: ./node_modules/@surfline/quiver-react/esm/Alert/Alert.js
var Alert = __webpack_require__(42537);
// EXTERNAL MODULE: ./node_modules/@surfline/quiver-react/esm/ContentContainer/ContentContainer.js
var ContentContainer = __webpack_require__(63301);
// EXTERNAL MODULE: ./node_modules/@surfline/web-common/esm/segment.js + 2 modules
var segment = __webpack_require__(59075);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@surfline/web-common/esm/structuredData.js
var structuredData = __webpack_require__(13728);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 3 modules
var format = __webpack_require__(32912);
// EXTERNAL MODULE: ./src/utils/urls/index.ts + 2 modules
var urls = __webpack_require__(25447);
// EXTERNAL MODULE: ./src/components/MetaTags/index.ts + 1 modules
var MetaTags = __webpack_require__(77998);
// EXTERNAL MODULE: ./src/config/index.ts + 1 modules
var config = __webpack_require__(49230);
;// CONCATENATED MODULE: ./src/components/PremiumAnalysisMeta/PremiumAnalysisMeta.js








var title = function(subregionName, timestamp) {
    return "Premium ".concat(subregionName, " Weather Forecast for Storms, Swell & Surf in ").concat((0,format/* default */.Z)(timestamp ? new Date(timestamp * 1000) : new Date(), "MMMM yyyy"), " - Surfline");
};
var description = function(subregionName) {
    return "The most accurate and trusted premium ".concat(subregionName, " surf reports, forecasts, and coastal weather. Surfers from around the world choose Surfline for daily forecasts and timely news").replace("  ", " ");
};
var PremiumAnalysisMeta = function(param) {
    var subregionId = param.subregionId, subregionName = param.subregionName, timestamp = param.timestamp, headline = param.headline, author = param.author;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTags/* default */.Z, {
        title: title(subregionName, timestamp),
        description: description(subregionName),
        urlPath: (0,urls/* subregionForecastPath */.xA)(subregionId, subregionName),
        parentUrl: (0,urls/* subregionForecastPath */.xA)(subregionId, subregionName),
        parentTitle: title(subregionName, timestamp),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
            type: "application/ld+json",
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML: {
                __html: (0,structuredData/* pageStructuredData */.l0)({
                    url: "".concat(config/* default.surflineHost */.Z.surflineHost).concat((0,urls/* subregionForecastPath */.xA)(subregionId, subregionName)),
                    headline: headline || title(subregionName, timestamp),
                    dateModified: "10/1/2019",
                    author: author || "Surfline Forecast Team",
                    description: description(subregionName),
                    cssSelector: ".sl-premium-analysis"
                })
            }
        })
    });
};
PremiumAnalysisMeta.propTypes = {
    subregionId: (prop_types_default()).string.isRequired,
    subregionName: (prop_types_default()).string.isRequired,
    timestamp: (prop_types_default()).number,
    headline: (prop_types_default()).string,
    author: (prop_types_default()).string
};
PremiumAnalysisMeta.defaultProps = {
    headline: null,
    author: null,
    timestamp: null
};
/* harmony default export */ var PremiumAnalysisMeta_PremiumAnalysisMeta = (PremiumAnalysisMeta);

;// CONCATENATED MODULE: ./src/components/PremiumAnalysisMeta/index.js


// EXTERNAL MODULE: ./node_modules/date-fns/esm/formatDistanceStrict/index.js
var formatDistanceStrict = __webpack_require__(12195);
// EXTERNAL MODULE: ./node_modules/@surfline/quiver-react/esm/GoogleDFP/GoogleDFP.js + 5 modules
var GoogleDFP = __webpack_require__(2810);
// EXTERNAL MODULE: ./node_modules/@surfline/quiver-react/esm/EditorialArticleCard/EditorialArticleCard.js + 1 modules
var EditorialArticleCard = __webpack_require__(26599);
// EXTERNAL MODULE: ./node_modules/@surfline/quiver-react/esm/ForecastArticleCard/ForecastArticleCard.js
var ForecastArticleCard = __webpack_require__(7800);
// EXTERNAL MODULE: ./node_modules/@surfline/web-common/esm/getWindow.js
var getWindow = __webpack_require__(32257);
// EXTERNAL MODULE: ./node_modules/@surfline/web-common/esm/canUseDOM.js
var canUseDOM = __webpack_require__(80660);
;// CONCATENATED MODULE: ./src/propTypes/article.js

/* harmony default export */ var article = (prop_types_default().shape({
    id: (prop_types_default()).string.isRequired,
    contentType: (prop_types_default()).string.isRequired,
    createdAt: (prop_types_default()).number.isRequired,
    updatedAt: (prop_types_default()).number.isRequired,
    promoted: prop_types_default().arrayOf((prop_types_default()).string),
    premium: (prop_types_default()).bool,
    content: prop_types_default().shape({
        title: (prop_types_default()).string.isRequired,
        subtitle: (prop_types_default()).string,
        body: (prop_types_default()).string
    }),
    permalink: (prop_types_default()).string,
    media: prop_types_default().shape({
        type: (prop_types_default()).string.isRequired,
        feed1x: (prop_types_default()).string.isRequired,
        feed2x: (prop_types_default()).string.isRequired,
        promobox1x: (prop_types_default()).string,
        promobox2x: (prop_types_default()).string
    }),
    author: prop_types_default().shape({
        iconUrl: (prop_types_default()).string.isRequired,
        name: (prop_types_default()).string.isRequired
    }),
    tags: prop_types_default().arrayOf(prop_types_default().shape({
        name: (prop_types_default()).string.isRequired,
        url: (prop_types_default()).string.isRequired
    }))
}));

;// CONCATENATED MODULE: ./src/propTypes/subregionAdConfig.js

/* harmony default export */ var subregionAdConfig = (prop_types_default().shape({
    adTarget: prop_types_default().arrayOf(prop_types_default().arrayOf((prop_types_default()).string)),
    userEntitlements: prop_types_default().arrayOf((prop_types_default()).string).isRequired,
    isUser: (prop_types_default()).bool.isRequired
}));

// EXTERNAL MODULE: ./src/utils/adConfig.js + 1 modules
var adConfig = __webpack_require__(9407);
;// CONCATENATED MODULE: ./src/components/FeedArticle/FeedArticle.js











var onClickPaywall = function(article, subregionId, subregionName) {
    var win = (0,getWindow/* default */.Z)();
    (0,segment/* trackClickedSubscribeCTA */.$b)({
        location: "premium analysis",
        contentId: article.id.toString(),
        subregionId: subregionId,
        subregionName: subregionName
    });
    if (canUseDOM/* default */.Z) win.location.assign("".concat(config/* default.surflineHost */.Z.surflineHost).concat(config/* default.funnelUrl */.Z.funnelUrl));
};
var FeedArticle = function(param) {
    var article = param.article, isPremium = param.isPremium, subregionAdConfig = param.subregionAdConfig, adIdentifier = param.adIdentifier, showFullArticle = param.showFullArticle, subregionName = param.subregionName, subregionId = param.subregionId;
    var PremiumAnalysisCTAComponent = (0,external_React_.useCallback)(function() {
        return (0,CTAs/* PremiumAnalysisCTA */.hU)({
            segmentProperties: {
                location: "premium analysis",
                contentId: article.id.toString(),
                subregionId: subregionId,
                subregionName: subregionName
            },
            link: config/* default.funnelUrl */.Z.funnelUrl
        });
    }, [
        article.id,
        subregionId,
        subregionName
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "sl-feed-article",
        children: [
            adIdentifier ? /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleDFP/* default */.Z, {
                adConfig: (0,adConfig/* default */.Z)(adIdentifier, subregionAdConfig.adTargets, subregionAdConfig.userEntitlements, subregionAdConfig.isUser),
                isHtl: true,
                isTesting: config/* default.htl.isTesting */.Z.htl.isTesting,
                useSheMedia: config/* default.she.useSheMedia */.Z.she.useSheMedia
            }, "googleDFP_".concat(article.id)) : null,
            article.contentType === "EDITORIAL" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EditorialArticleCard/* default */.Z, {
                author: article.author.name,
                externalLink: article.externalLink,
                externalSource: article.externalSource,
                newWindow: article.newWindow,
                publishedDateTime: (0,formatDistanceStrict/* default */.Z)(article.updatedAt * 1000, new Date()),
                premium: article.premium,
                title: article.content.title,
                subtitle: article.content.subtitle,
                permalink: article.permalink,
                media: article.media,
                tags: article.tags,
                showPaywall: false,
                funnelUrl: config/* default.funnelUrl */.Z.funnelUrl,
                onClickContent: function() {
                    return (0,segment/* trackEvent */.L9)("Clicked Regional Feed Link", {
                        category: "Regional Feed",
                        location: "premium analysis",
                        destinationUrl: article.permalink,
                        mediaType: article.media && article.media.type ? article.media.type : null,
                        contentId: article.id
                    });
                },
                onClickPaywall: function() {
                    return onClickPaywall(article, subregionId, subregionName);
                },
                onClickTag: function(tag) {
                    return (0,segment/* trackEvent */.L9)("Clicked Regional Feed Link", {
                        category: "Regional Feed",
                        location: "premium analysis",
                        destinationUrl: tag.url,
                        mediaType: article.media && article.media.type ? article.media.type : null,
                        contentId: article.id
                    });
                }
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ForecastArticleCard/* default */.Z, {
                publishedDateTime: (0,formatDistanceStrict/* default */.Z)(article.updatedAt * 1000, new Date()),
                premium: article.premium,
                expert: article.promoted ? article.promoted.includes("REGIONAL") : false,
                title: article.content.title,
                body: article.content.body,
                author: article.author ? article.author.name : null,
                id: article.id,
                tags: article.tags,
                showPaywall: !isPremium && article.premium,
                CustomPaywallCTA: PremiumAnalysisCTAComponent,
                isPremium: isPremium,
                funnelUrl: config/* default.funnelUrl */.Z.funnelUrl,
                showFullArticle: showFullArticle,
                onClickPaywall: function() {
                    return onClickPaywall(article, subregionId, subregionName);
                },
                onClickReadMore: function() {
                    return (0,segment/* trackEvent */.L9)("Clicked Read More", {
                        location: "premium analysis",
                        contentId: article.id,
                        title: article.content.title,
                        premiumArticle: article.premium,
                        subregionId: subregionId,
                        subregionName: subregionName
                    });
                },
                onClickShareArticle: function(shareChannel) {
                    return (0,segment/* trackEvent */.L9)("Clicked Share Icon", {
                        title: article.content.title,
                        contentId: "".concat(article.id),
                        tags: article.tags.map(function(tag) {
                            return tag.name;
                        }).join(","),
                        locationCategory: "Premium Analysis",
                        destinationUrl: article.permalink,
                        mediaType: article.media ? article.media.type : null,
                        shareChannel: shareChannel
                    });
                },
                segmentCategory: "Regional Feed",
                fbAppId: config/* default.appKeys.fbAppId */.Z.appKeys.fbAppId,
                url: article.permalink,
                showShare: isPremium
            })
        ]
    });
};
FeedArticle.propTypes = {
    article: article.isRequired,
    adIdentifier: (prop_types_default()).string,
    isPremium: (prop_types_default()).bool.isRequired,
    subregionAdConfig: subregionAdConfig.isRequired,
    showFullArticle: (prop_types_default()).bool.isRequired,
    subregionName: (prop_types_default()).string.isRequired,
    subregionId: (prop_types_default()).string.isRequired
};
FeedArticle.defaultProps = {
    adIdentifier: null
};
/* harmony default export */ var FeedArticle_FeedArticle = (FeedArticle);

;// CONCATENATED MODULE: ./src/components/FeedArticle/index.js


;// CONCATENATED MODULE: ./src/components/FeedList/FeedList.js






var FeedList = function(param) {
    var articles = param.articles, isPremium = param.isPremium, subregionAdConfig = param.subregionAdConfig, subregionName = param.subregionName, subregionId = param.subregionId, showFullArticle = param.showFullArticle;
    var getAdIdentifier = function(index) {
        if (index === 2) return "forecastFeedMobile";
        if (index === 10) return "forecastFeedMobileBottom";
        return null;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "sl-feed-list",
        children: articles.map(function(article, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FeedArticle_FeedArticle, {
                article: article,
                adIdentifier: getAdIdentifier(index),
                subregionAdConfig: subregionAdConfig,
                isPremium: isPremium,
                subregionName: subregionName,
                subregionId: subregionId,
                showFullArticle: showFullArticle
            }, "feedArticle_".concat(article.id));
        })
    });
};
FeedList.propTypes = {
    articles: prop_types_default().arrayOf(article).isRequired,
    isPremium: (prop_types_default()).bool.isRequired,
    subregionAdConfig: subregionAdConfig.isRequired,
    subregionName: (prop_types_default()).string.isRequired,
    subregionId: (prop_types_default()).string.isRequired,
    showFullArticle: (prop_types_default()).bool.isRequired
};
/* harmony default export */ var FeedList_FeedList = (FeedList);

;// CONCATENATED MODULE: ./src/components/FeedList/index.js


// EXTERNAL MODULE: ./src/selectors/subregion.js
var subregion = __webpack_require__(37885);
;// CONCATENATED MODULE: ./src/utils/getOrderedArticles.ts
var getOrderedArticles = function(articles) {
    var shorttermforecast = articles.find(function(article) {
        var ref;
        return (article === null || article === void 0 ? void 0 : (ref = article.keywords) === null || ref === void 0 ? void 0 : ref[0]) === "shorttermforecast";
    });
    var longtermforecast = articles.find(function(article) {
        var ref;
        return (article === null || article === void 0 ? void 0 : (ref = article.keywords) === null || ref === void 0 ? void 0 : ref[0]) === "longtermforecast";
    });
    var seasonalforecast = articles.find(function(article) {
        var ref;
        return (article === null || article === void 0 ? void 0 : (ref = article.keywords) === null || ref === void 0 ? void 0 : ref[0]) === "seasonalforecast";
    });
    return [
        shorttermforecast,
        longtermforecast,
        seasonalforecast
    ].filter(function(article) {
        return article;
    });
};
/* harmony default export */ var utils_getOrderedArticles = (getOrderedArticles);

// EXTERNAL MODULE: ./src/propTypes/userDetails.js
var userDetails = __webpack_require__(26234);
;// CONCATENATED MODULE: ./src/propTypes/subregionOverviewData.js

/* harmony default export */ var subregionOverviewData = (prop_types_default().shape({
    _id: (prop_types_default()).string,
    name: (prop_types_default()).string,
    primarySpot: (prop_types_default()).string,
    spots: prop_types_default().arrayOf(prop_types_default().shape({
        _id: (prop_types_default()).string,
        name: (prop_types_default()).string,
        conditions: prop_types_default().shape({
            human: (prop_types_default()).bool,
            value: (prop_types_default()).string
        }),
        waveHeight: prop_types_default().shape({
            human: (prop_types_default()).bool,
            min: (prop_types_default()).number,
            max: (prop_types_default()).number,
            occasional: (prop_types_default()).number,
            humanRelation: (prop_types_default()).string,
            plus: (prop_types_default()).bool
        }),
        lat: (prop_types_default()).number,
        lon: (prop_types_default()).number
    })),
    timestamp: (prop_types_default()).number,
    forecastSummary: prop_types_default().shape({
        forecastStatus: prop_types_default().shape({
            status: (prop_types_default()).string,
            inactiveMessage: (prop_types_default()).string
        }),
        nextForecast: prop_types_default().shape({
            timestamp: (prop_types_default()).number,
            utcOffset: (prop_types_default()).number
        }),
        forecaster: prop_types_default().shape({
            name: (prop_types_default()).string,
            title: (prop_types_default()).string,
            email: (prop_types_default()).string
        }),
        highlights: prop_types_default().arrayOf((prop_types_default()).string),
        breadcrumb: prop_types_default().arrayOf(prop_types_default().shape({
            name: (prop_types_default()).string,
            href: (prop_types_default()).string
        }))
    })
}));

// EXTERNAL MODULE: ./src/selectors/user.ts
var selectors_user = __webpack_require__(77986);
// EXTERNAL MODULE: ./src/utils/renderCustomComponents.js + 4 modules
var renderCustomComponents = __webpack_require__(50147);
;// CONCATENATED MODULE: ./src/containers/PremiumAnalysis/PremiumAnalysis.js

























var PremiumAnalysis = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(PremiumAnalysis, Component);
    var _super = (0,_create_super/* default */.Z)(PremiumAnalysis);
    function PremiumAnalysis() {
        (0,_class_call_check/* default */.Z)(this, PremiumAnalysis);
        var _this;
        _this = _super.apply(this, arguments);
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "PremiumAnalysisContent", function(param) {
            var feed = param.feed, articles = param.articles, overviewData = param.overviewData, isPremium = param.isPremium, subregionId = param.subregionId, subregionAdConfig = param.subregionAdConfig;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "sl-premium-analysis__content",
                children: [
                    feed.loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {}),
                    feed.error && /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                        error: true
                    }),
                    feed.articles.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(FeedList_FeedList, {
                        articles: articles,
                        subregionAdConfig: subregionAdConfig,
                        isPremium: isPremium,
                        subregionName: overviewData.name,
                        subregionId: subregionId,
                        showFullArticle: true
                    }),
                    feed.articles.length === 0 && !feed.loading && !feed.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "sl-premium-analysis__message",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Alert/* default */.Z, {
                            children: [
                                "Premium Analysis currently unavailable for this region.",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "mailto:forecast_feedback@surfline.com",
                                    children: "Feedback?"
                                })
                            ]
                        })
                    })
                ]
            });
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(PremiumAnalysis, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _props = this.props, isPremium = _props.isPremium, jwPlayerLoaded = _props.jwPlayerLoaded, _overviewData = _props.overviewData, name = _overviewData.name, _id = _overviewData._id, forecastSummary = _overviewData.forecastSummary, trackPage = _props.trackPage;
                if (trackPage !== false) {
                    var ref;
                    (0,segment/* trackNavigatedToPage */.Dr)("Premium Analysis", {
                        category: "forecast",
                        channel: "forecast",
                        human: (forecastSummary === null || forecastSummary === void 0 ? void 0 : (ref = forecastSummary.forecastStatus) === null || ref === void 0 ? void 0 : ref.status) === "active" && ((forecastSummary === null || forecastSummary === void 0 ? void 0 : forecastSummary.hasHighlights) || (forecastSummary === null || forecastSummary === void 0 ? void 0 : forecastSummary.hasBets)),
                        subregionId: _id,
                        subregionName: name,
                        viewedLocation: "regional"
                    });
                }
                (0,renderCustomComponents/* renderTwitterElements */.PR)();
                (0,renderCustomComponents/* renderIgElements */.lN)();
                if (jwPlayerLoaded) {
                    (0,renderCustomComponents/* renderCameraEmbeds */.cA)(isPremium);
                }
                (0,renderCustomComponents/* renderJWElements */.Ru)();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _props = this.props, isPremium = _props.isPremium, jwPlayerLoaded = _props.jwPlayerLoaded;
                if (!prevProps.jwPlayerLoaded && jwPlayerLoaded) {
                    (0,renderCustomComponents/* renderCameraEmbeds */.cA)(isPremium);
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                (0,renderCustomComponents/* unmountJWElements */.Iz)();
            }
        },
        {
            key: "render",
            value: function render() {
                var ref, ref1;
                var _props = this.props, feed = _props.feed, isPremium = _props.isPremium, userDetails = _props.userDetails, entitlements = _props.entitlements, overviewData = _props.overviewData, router = _props.router;
                var subregionId = router.query.subregionId;
                var subregionAdConfig = (0,adConfig/* subregionForecastAdBaseConfig */.$)(subregionId, entitlements, !!userDetails);
                var articles = feed.articles.length ? utils_getOrderedArticles(feed.articles) : [];
                var _articles = (0,_sliced_to_array/* default */.Z)(articles, 1), firstArticle = _articles[0];
                var headline = firstArticle === null || firstArticle === void 0 ? void 0 : (ref = firstArticle.content) === null || ref === void 0 ? void 0 : ref.title;
                var author = firstArticle === null || firstArticle === void 0 ? void 0 : (ref1 = firstArticle.author) === null || ref1 === void 0 ? void 0 : ref1.name;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "sl-premium-analysis",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PremiumAnalysisMeta_PremiumAnalysisMeta, {
                            subregionName: overviewData.name,
                            subregionId: subregionId,
                            timestamp: overviewData.timestamp,
                            headline: headline,
                            author: author
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentContainer/* default */.Z, {
                            children: this.PremiumAnalysisContent({
                                feed: feed,
                                articles: articles,
                                overviewData: overviewData,
                                subregionId: subregionId,
                                isPremium: isPremium,
                                subregionAdConfig: subregionAdConfig
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return PremiumAnalysis;
}(external_React_.Component);
PremiumAnalysis.defaultProps = {
    entitlements: [],
    isPremium: null,
    overviewData: null,
    trackPage: true,
    userDetails: null
};
PremiumAnalysis.propTypes = {
    jwPlayerLoaded: (prop_types_default()).bool.isRequired,
    isPremium: (prop_types_default()).bool,
    userDetails: userDetails/* default */.Z,
    entitlements: prop_types_default().arrayOf((prop_types_default()).string),
    router: prop_types_default().shape({
        query: prop_types_default().shape({
            subregionId: (prop_types_default()).string.isRequired
        }).isRequired
    }).isRequired,
    overviewData: subregionOverviewData,
    feed: prop_types_default().shape({
        loading: (prop_types_default()).bool,
        error: (prop_types_default()).string,
        articles: prop_types_default().arrayOf(article)
    }).isRequired,
    trackPage: (prop_types_default()).bool
};
/* harmony default export */ var PremiumAnalysis_PremiumAnalysis = ((0,es/* connect */.$j)(function(state) {
    return {
        overviewData: (0,subregion/* getSubregionOverviewData */.em)(state),
        isPremium: (0,selectors_user/* getUserIsEntitled */.Ml)(state, permissions/* SL_PREMIUM_FORECASTS */.aE),
        userDetails: (0,user/* getUserDetails */.M_)(state),
        entitlements: (0,user/* getEntitlements */.HF)(state),
        feed: state.subregion.feed
    };
})((0,router.withRouter)(PremiumAnalysis)));

;// CONCATENATED MODULE: ./src/containers/PremiumAnalysis/index.js


// EXTERNAL MODULE: ./src/hooks/useJWPlayer.ts
var useJWPlayer = __webpack_require__(52117);
// EXTERNAL MODULE: ./src/stores/index.ts + 60 modules
var stores = __webpack_require__(57657);
;// CONCATENATED MODULE: ./src/utils/getSpotPageRedirectURL.ts

var getSpotPageRedirectURL = function(param) {
    var data = param.data, feedArticles = param.feedArticles, primarySpotId = param.primarySpotId;
    var path = "";
    if ((feedArticles === null || feedArticles === void 0 ? void 0 : feedArticles.length) === 0) {
        var ref, ref1, ref2;
        var spotDetails = data === null || data === void 0 ? void 0 : (ref = data.spots) === null || ref === void 0 ? void 0 : ref.filter(function(spot) {
            return (spot === null || spot === void 0 ? void 0 : spot._id) === primarySpotId;
        });
        path = (0,urls/* spotReportPath */.VK)({}, {
            _id: (spotDetails === null || spotDetails === void 0 ? void 0 : (ref1 = spotDetails[0]) === null || ref1 === void 0 ? void 0 : ref1._id) || "",
            name: (spotDetails === null || spotDetails === void 0 ? void 0 : (ref2 = spotDetails[0]) === null || ref2 === void 0 ? void 0 : ref2.name) || "spot"
        });
    }
    return path;
};
/* harmony default export */ var utils_getSpotPageRedirectURL = (getSpotPageRedirectURL);

// EXTERNAL MODULE: ./src/utils/getCloudflareCountryCode.ts
var getCloudflareCountryCode = __webpack_require__(13842);
// EXTERNAL MODULE: ./src/pages/surf-forecasts/[subregionSlug]/[subregionId]/SubregionForecastPage.module.scss
var SubregionForecastPage_module = __webpack_require__(20082);
var SubregionForecastPage_module_default = /*#__PURE__*/__webpack_require__.n(SubregionForecastPage_module);
;// CONCATENATED MODULE: ./src/pages/surf-forecasts/[subregionSlug]/[subregionId]/index.tsx





















var SubregionForecastPage = function() {
    var overviewData = (0,es/* useSelector */.v9)(subregion/* getSubregionOverviewData */.em);
    var isPremium = (0,es/* useSelector */.v9)(user/* getUserPremiumStatus */.u6);
    var ref = (0,useJWPlayer/* default */.Z)(), jwPlayerLoaded = ref.jwPlayerLoaded, setJwPlayerLoaded = ref.setJwPlayerLoaded;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            overviewData && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    className: "sl-subregion-forecast-page",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                            id: "jw-player",
                            strategy: "afterInteractive",
                            src: constants/* JW_PLAYER_URL */.Pi,
                            onLoad: function() {
                                return setJwPlayerLoaded(true);
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            className: (SubregionForecastPage_module_default()).regionalAnalysisContainer,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PremiumAnalysis_PremiumAnalysis, {
                                jwPlayerLoaded: jwPlayerLoaded
                            })
                        })
                    ]
                })
            }),
            !isPremium && /*#__PURE__*/ (0,jsx_runtime.jsx)(CTAs/* PremiumFCSTUpgradePill */.MJ, {})
        ]
    });
};
SubregionForecastPage.getInitialProps = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(context) {
        var store, dispatch, res, req, query, subregionSlug, subregionId, cookies, clientIp, isServer, countryCode, subregion, ref, ref1, ref2, redirectUrl, newrelic;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    store = (0,stores/* getOrCreateStore */._g)();
                    dispatch = store.dispatch;
                    res = context.res, req = context.req, query = context.query;
                    subregionSlug = query.subregionSlug, subregionId = query.subregionId;
                    cookies = (req === null || req === void 0 ? void 0 : req.cookies) || {};
                    clientIp = (0,getClientIp/* default */.Z)(context.req);
                    isServer = !!req;
                    countryCode = (0,getCloudflareCountryCode/* default */.Z)(req);
                    return [
                        4,
                        dispatch((0,actions_subregion/* setSubregionLoading */.UD)(true))
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        Promise.all([
                            dispatch((0,actions_subregion/* fetchOverviewData */.ho)(subregionId, cookies, clientIp, true, function(overview) {
                                return dispatch((0,actions_user/* setUserPermissions */.$I)({
                                    requestedPermissions: [
                                        permissions/* SL_PREMIUM_FORECASTS */.aE
                                    ],
                                    permissions: overview === null || overview === void 0 ? void 0 : overview.permissions
                                }));
                            }, countryCode)),
                            dispatch((0,actions_subregion/* fetchNearbySubregions */.kG)(subregionId, cookies)),
                            dispatch((0,actions_subregion/* fetchRegionalArticles */.el)(subregionId, cookies, isServer)),
                            dispatch((0,swellEvents/* fetchSwellEvents */.aV)(subregionId, "subregion"))
                        ])
                    ];
                case 2:
                    _state.sent();
                    dispatch((0,actions_subregion/* setSubregionLoading */.UD)(false));
                    subregion = store.getState().subregion;
                    if (subregion) {
                        ;
                        redirectUrl = utils_getSpotPageRedirectURL({
                            data: subregion === null || subregion === void 0 ? void 0 : (ref = subregion.overview) === null || ref === void 0 ? void 0 : (ref1 = ref.overview) === null || ref1 === void 0 ? void 0 : ref1.data,
                            feedArticles: subregion === null || subregion === void 0 ? void 0 : (ref2 = subregion.feed) === null || ref2 === void 0 ? void 0 : ref2.articles,
                            primarySpotId: subregion === null || subregion === void 0 ? void 0 : subregion.primarySpotId
                        });
                        if ((res === null || res === void 0 ? void 0 : res.locals) && redirectUrl) {
                            res.locals.redirectUrlFromPremiumAnalysis = redirectUrl;
                        }
                    }
                    if (isServer) {
                        newrelic = __webpack_require__(69160);
                        newrelic.addCustomAttributes({
                            subregionSlug: subregionSlug,
                            subregionId: subregionId
                        });
                        return [
                            2,
                            {
                                enableCssBaseline: true,
                                enableTheme: true,
                                isSubregionForecastPage: true,
                                librariesToLoad: {
                                    jwplayer: true
                                },
                                ssrReduxState: store.getState()
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            enableCssBaseline: true,
                            enableTheme: true,
                            isSubregionForecastPage: true,
                            librariesToLoad: {
                                jwplayer: true
                            }
                        }
                    ];
            }
        });
    });
    return function(context) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var _subregionId_ = (SubregionForecastPage);


/***/ }),

/***/ 26234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ __webpack_exports__["Z"] = (prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({
    _id: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),
    email: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),
    firstName: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),
    lastName: (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string)
}));


/***/ }),

/***/ 13842:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var getCloudflareCountryCode = function(req) {
    var ref, ref1, ref2;
    return !!req && (req === null || req === void 0 ? void 0 : (ref = req.headers) === null || ref === void 0 ? void 0 : ref["cf-ipcountry"]) ? req === null || req === void 0 ? void 0 : (ref1 = req.headers) === null || ref1 === void 0 ? void 0 : (ref2 = ref1["cf-ipcountry"]) === null || ref2 === void 0 ? void 0 : ref2.toString() : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (getCloudflareCountryCode);


/***/ }),

/***/ 20082:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"regionalAnalysisContainer":"SubregionForecastPage_regionalAnalysisContainer__r_wLU"};

/***/ }),

/***/ 69160:
/***/ (function(module) {

"use strict";
module.exports = newrelic;

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6886,5346,2836,1023,2819,7997,1033,9588,3945,6682,1344,503,147,9774,2888,179], function() { return __webpack_exec__(24736); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);